import { render, staticRenderFns } from "./DialogCloseTimer.vue?vue&type=template&id=056b06d9&scoped=true&lang=pug"
import script from "./DialogCloseTimer.vue?vue&type=script&lang=js"
export * from "./DialogCloseTimer.vue?vue&type=script&lang=js"
import style0 from "./DialogCloseTimer.vue?vue&type=style&index=0&id=056b06d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b06d9",
  null
  
)

export default component.exports